export class GetCUPPgUnRegularPlanAddNew{
    Years: string = ''
    DeptNo: string = ''
    TeamNo: string = ''
    AcadCourseNo: string = ''
    CosList: string = ''
    CosCluster: string = ''
    MustPassNum: number = 0
}